export default "/assets/images/smiling-girl-2.e9a9865ad4ba351c.png";